import { Code2, Database, Palette, Globe, Coins, Briefcase } from "lucide-react";

export const skillsData = {
  "Languages & Tools": ["Java", "TypeScript", "SQL", "Python", "OCaml", "HTML", "CSS", "Git", "Node.js", "MCP"],
  "Data Science": [
    "SQL Analytics",
    "Metabase",
    "Data Visualization",
    "Causal Inference",
    "Machine Learning",
    "DevOps",
    "Docker",
  ],
  "UI/UX": ["Responsive Design", "Mobile-First", "User Experience", "Frontend Optimization", "Figma"],
  "Web Development": [
    "React",
    "AngularJS",
    "Vite",
    "Next.js",
    "C#",
    "API Development",
    "SEO Optimization",
    "Google Tag Manager",
  ],
  "Blockchain": ["Cryptocurrency", "Liquidity Pools", "Smart Contracts", "Yield Farming", "DeFi", "Stablecoins"],
  "Product Management": ["Finance", "Go-to-Market Strategy", "Fundraising", "User Research", "A/B Testing"]
};

export const categoryIcons = {
  "Languages & Tools": Code2,
  "Data Science": Database,
  "UI/UX": Palette,
  "Web Development": Globe,
  Blockchain: Coins,
  "Product Management": Briefcase,
};
